import { render, staticRenderFns } from "./Pay2.vue?vue&type=template&id=f278ddfc&scoped=true"
import script from "./Pay2.vue?vue&type=script&lang=js"
export * from "./Pay2.vue?vue&type=script&lang=js"
import style0 from "./Pay2.vue?vue&type=style&index=0&id=f278ddfc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f278ddfc",
  null
  
)

export default component.exports